import { Grid } from '@uikit';
import { Logo } from '../Logo/Logo';
import classes from './header.module.scss';

export const Header = () => (
  <header className={classes.header}>
    <Grid.Container>
      <Grid.Column className={classes.header_itemsContainer}>
        <Logo />
      </Grid.Column>
    </Grid.Container>
  </header>
);
